import { render, staticRenderFns } from "./QRReceipt.vue?vue&type=template&id=7808aa4e"
import script from "./QRReceipt.vue?vue&type=script&lang=js"
export * from "./QRReceipt.vue?vue&type=script&lang=js"
import style0 from "./QRReceipt.vue?vue&type=style&index=0&id=7808aa4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports